import ReactModal from 'react-modal';
import { modalStyle } from '../../../../../../../utils/modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

function RewardAssignToModal({
  assignToModal,
  closeModal,
  aggregators,
  rewardAssignTo,
  setReward,
}) {
  const [editMode, setEditMode] = useState(false);

  const [aggregatorIds, setAggregatorIds] = useState(rewardAssignTo.aggregators);

  useEffect(() => {
    if (rewardAssignTo) {
      setAggregatorIds(rewardAssignTo.aggregators);
    }
  }, [rewardAssignTo]);

  const handleUpdate = () => {
    setReward(prev => ({ ...prev, assignTo: { ...prev.assignTo, aggregators: aggregatorIds } }));
    closeModal();
  };

  const close = () => {
    setAggregatorIds(rewardAssignTo.aggregators);
    closeModal();
  };

  return (
    <ReactModal
      isOpen={!!assignToModal}
      style={modalStyle({ width: '460px' })}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onRequestClose={close}
    >
      <div className="bo-modal-form">
        <div>
          <div className="gap-3 d-flex flex-column">
            <div className="d-flex flex-column">
              <Form.Label>Aggregators</Form.Label>
              {aggregatorIds.length === 0 ? (
                <Form.Select
                  className="bo-filter w-100"
                  onChange={e => setAggregatorIds(prev => [...prev, Number(e.target.value)])}
                >
                  <option value="">All Aggregators</option>
                  {aggregators.map(agg => (
                    <option key={agg.id} value={agg.id}>
                      {agg.name}
                    </option>
                  ))}
                </Form.Select>
              ) : (
                <div className="d-flex flex-column gap-2">
                  {aggregatorIds.map(x => (
                    <div key={x} className="d-flex gap-2 align-items-center">
                      <Form.Control
                        className="bo-input w-100"
                        readOnly
                        value={aggregators.find(agg => agg.id === x)?.name}
                      />
                      <Button
                        className="bo-common-base-button"
                        onClick={() => setAggregatorIds(pAggs => pAggs.filter(pAgg => pAgg !== x))}
                      >
                        <FontAwesomeIcon icon={faTrashAlt} color="#5946A4" size="1x" />
                      </Button>
                    </div>
                  ))}
                  {editMode ? (
                    <Form.Select
                      className="bo-filter w-100"
                      defaultValue=""
                      onChange={e => {
                        setEditMode(false);
                        setAggregatorIds(prev => [...prev, Number(e.target.value)]);
                      }}
                    >
                      <option value="" disabled>
                        Select Aggregator...
                      </option>
                      {aggregators
                        .filter(agg => !aggregatorIds.includes(agg.id))
                        .map(agg => (
                          <option key={agg.id} value={agg.id}>
                            {agg.name}
                          </option>
                        ))}
                    </Form.Select>
                  ) : (
                    <Button
                      className="bo-common-inline-button align-self-start ms-2"
                      onClick={() => setEditMode(true)}
                    >
                      Add Aggregator
                    </Button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <Row>
          <Col className="mt-5 d-flex gap-3 justify-content-between">
            <Button className="bo-button" onClick={handleUpdate}>
              OK
            </Button>
            <Button className="bo-button" onClick={close}>
              Cancel
            </Button>
          </Col>
        </Row>
      </div>
    </ReactModal>
  );
}

export default RewardAssignToModal;
